import { render } from "./Sandwich.vue?vue&type=template&id=8cf958b2&scoped=true"
import script from "./Sandwich.vue?vue&type=script&lang=js"
export * from "./Sandwich.vue?vue&type=script&lang=js"

import "./Sandwich.vue?vue&type=style&index=0&id=8cf958b2&lang=sass&scoped=true"

import exportComponent from "/home/frappe/ONEFM_Landing_page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf958b2"]])

export default __exports__